import update from 'immutability-helper';
import RulerToolEnum from 'RulerTool/RulerToolConstants';

const DEFAULT_COLOR = 'red';

const RulerToolReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return {
      color: DEFAULT_COLOR,
      isRulerActive: false,
      rulerToggledOn: false,
    };
  }

  switch (action.type) {
    case RulerToolEnum.TOGGLE_RULER_TOOL: {
      return update(state, { rulerToggledOn: { $set: !state.rulerToggledOn } });
    }
    case RulerToolEnum.RULER_IS_ACTIVE: {
      return update(state, { isRulerActive: { $set: action.active } });
    }
    case RulerToolEnum.SET_RULER_COLOR: {
      return update(state, { color: { $set: action.color } });
    }
    default:
      return state;

  }
};

export default RulerToolReducer;



// WEBPACK FOOTER //
// ./src-react/RulerTool/RulerToolReducer.jsx